import React, { useCallback } from "react";
import { Grid} from "semantic-ui-react";
import DeleteIcon from "@commonComponents/deleteIcon";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { selectSupplyChainRoleList } from "./selectors";
import { useSelector } from "react-redux";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const AddtionalSupplyChainForm = ({ dataSource, deleteData, tableName, onChange, onSelect, onBlur, renderAtLast }) => {
  const { isDisabled } = useCurrentShipmentType();
  const {id,role,eoriNo}=dataSource
  const onChangeHandler=useCallback(({target:{value,name}})=>onChange(id,tableName,{[name]:value}),[tableName,id,onChange])
  const onDropDownChange=useCallback((e, {value,name})=>{

    const extraPayload={}
    if(name!="role")
         extraPayload.role=role         

    onSelect(id,tableName,{[name]:value,id,...extraPayload}, name)
  },[tableName,id,onSelect,role])

  const onBlurHandler=useCallback(({target:{value,name}})=>onBlur(tableName,{[name]:value,id, role},name),[tableName,id,onBlur,role])
  
  const supplyChainRoleList=useSelector(selectSupplyChainRoleList)
  const disableFields=role ? false : true
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column>
          <DropDown
            id={`role-${id}`}
            label='ROLE' //{translate("ROLE", {ns:["default", "parties"]})}
            labelClass='text-none'
            name='role'
            data={supplyChainRoleList}
            value={role}
            text={role}
            onChange={onDropDownChange}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`supplyIdentify-${id}`}
            type='text'
            label='IDENTIFICATION'
            name='eoriNo'
            value={eoriNo}
            clearInput={false}
            isDisabled={disableFields || isDisabled}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        {renderAtLast &&
          renderAtLast({ dataSource, onDropDownChange, disableFields, isDisabled, onSelect, tableName })}
      </Grid.Row>
      <div className='actionbtns'>
        <DeleteIcon onClick={() => deleteData(id, tableName, { role })} />
      </div>
    </div>
  )
}
AddtionalSupplyChainForm.defaultProps = {
    translate:(value)=>value
  }
export default React.memo(AddtionalSupplyChainForm)
